document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll(".btn--dropdown");
  containers.forEach((ctn) => {
    const trigger = ctn.querySelector(".dropdown__trigger");
    const indicator = ctn.querySelector(".dropdown__indicator");
    const dropdown = ctn.querySelector(".dropdown__list");
    if (!trigger || !dropdown) return;
    trigger.addEventListener("click", () => {
      dropdown.classList.toggle("hidden");
      if (!indicator) return;
      indicator.classList.toggle("rotate-90");
    });
  });
  document.addEventListener("click", (event) => {
    containers.forEach((ctn) => {
      const indicator = ctn.querySelector(".dropdown__indicator");
      const dropdown = ctn.querySelector(".dropdown__list");
      if (!dropdown) return;
      if (ctn.contains(event.target)) return;
      dropdown.classList.add("hidden");
      if (!indicator) return;
      indicator.classList.remove("rotate-90");
    });
  });
});
